var map = {
	"./BarCode/Attr": [
		2906,
		906
	],
	"./BitMap/Attr": [
		3785,
		785
	],
	"./CircleShape/Attr": [
		185,
		185
	],
	"./CutLine/Attr": [
		1076,
		76
	],
	"./Group/Attr": [
		2334,
		334
	],
	"./LineShape/Attr": [
		866,
		866
	],
	"./QrCode/Attr": [
		9596,
		596
	],
	"./RectShape/Attr": [
		4884,
		884
	],
	"./Separator/Attr": [
		7070,
		70
	],
	"./VButton/Attr": [
		3924,
		924
	],
	"./VTable/Attr": [
		8730,
		730
	],
	"./VText/Attr": [
		8319,
		319
	],
	"./svgs/SVGStar/Attr": [
		6703,
		703
	],
	"./svgs/SVGTriangle/Attr": [
		8316,
		316
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8968;
module.exports = webpackAsyncContext;